import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {DiscordInstance} from '../../discord/DiscordInstance'
import {SDKRequest} from '../../../../../shared/DiscordActivityTypes'
import {
    createDivIn,
    createExternalImgIn,
    createSpanIn,
    setElementInnerHTML,
    setElementOnClick,
} from '../../../../shared/scripts/ui_utils/DomUtils'
import {DiscordContentFrameController} from '../../discord/content_frame/DiscordContentFrameController'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue, ReferralTypeEnum, ShareActivityLinkAnalytics} from '../../../../../shared/entity_datas/EntityDatas'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {clientI18n} from '../../../../shared/scripts/ClientI18n'
import IconDiscord from '@static/images/icon_discord.svg'
import {AudioManager, AudioType} from '@colonist/audio'

export class UIDRoomInviteFriendsController {
    private readonly inviteFriendsButton: HTMLDivElement
    private roomId: string

    constructor(container: HTMLElement) {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return

        const inviteFriendsContainer = createDivIn(container, 'room_friend_container invite_discord_friends')
        if(UIUtilsEjsVariables.isUserOnDiscordMobile) inviteFriendsContainer.classList.add('discord_mobile')

        this.inviteFriendsButton = createDivIn(inviteFriendsContainer, 'btn_invite_friend btn_general')
        this.setInviteFriendsButtonText()

        const discordInstance = DiscordInstance.getDiscordInstance()
        if(UIDRoomInviteFriendsController.shouldHideInviteFriendsButton(discordInstance)) {
            inviteFriendsContainer.hidden = true
            return
        }

        setElementOnClick(this.inviteFriendsButton, () => {
            AudioManager.play(AudioType.Click)
            this.updateButtonTextWhileInviting()
            UIDRoomInviteFriendsController.sendClickAnalytic()

            if(UIDRoomInviteFriendsController.shouldShareActivityLink(discordInstance)) {
                discordInstance.sendSDKRequest(SDKRequest.ShareActivityLink, {
                    message: clientI18n.t('strings:homePage.popups.discordRoomInvitationUsingShareActivityLink.text'),
                    referralTypeId: `${ReferralTypeEnum.RoomInvitationUsingShareActivityLink.toString()}+room=${this.roomId}`,
                    analyticsPopupTriggered: ShareActivityLinkAnalytics.RoomInvitationUsingShareActivityLinkPopupTriggered,
                    analyticsPopupSuccess: ShareActivityLinkAnalytics.RoomInvitationUsingShareActivityLinkSuccessfullyShared,
                })
                return
            }

            DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.InviteFriends)
        })

        this.inviteFriendsButton.onmouseover = () => this.deanimateInviteFriendsButton()
    }

    setRoomId(roomId: string) {
        this.roomId = roomId
    }

    private static shouldHideInviteFriendsButton(discordInstance: DiscordContentFrameController): boolean {
        if(!discordInstance.inDiscordServer) return false
        if(!discordInstance.canInviteFriends) return true
        return false
    }

    private static shouldShareActivityLink(discordInstance: DiscordContentFrameController): boolean {
        if(!discordInstance.inDiscordServer) return true
        return false
    }

    private updateButtonTextWhileInviting() {
        const buttonTextChangeDuration = 3000
        setElementInnerHTML(this.inviteFriendsButton, {key: 'strings:roomPage.inviting'})
        setTimeout(() => this.setInviteFriendsButtonText(), buttonTextChangeDuration)
    }

    private setInviteFriendsButtonText() {
        setElementInnerHTML(this.inviteFriendsButton, {key: 'strings:colonistCommon.utils.emptyString'})
        const textSpan = createSpanIn(this.inviteFriendsButton, 'btn_invite_friends_text', {key: 'strings:roomPage.inviteFriends'})
        textSpan.append(' ')
        createExternalImgIn(textSpan, IconDiscord, {key: 'strings:colonistCommon.utils.emptyString'})
    }

    private static sendClickAnalytic() {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.InviteFriendButtonLeft,
        }
        void CA.sendAnalyticEvent(eventData)
    }

    private deanimateInviteFriendsButton() {
        this.inviteFriendsButton.classList.remove('btn-wiggle')
    }

    animateInviteFriendsButton() {
        this.inviteFriendsButton.classList.add('btn-wiggle')
    }
}
